import { render, staticRenderFns } from "./account-transcription-user-enablement.vue?vue&type=template&id=004d54ae"
import script from "./account-transcription-user-enablement.vue?vue&type=script&lang=js"
export * from "./account-transcription-user-enablement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports